import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetMultipleDomainsCommand } from '@/app/domain-chooser/commands/get-multiple-domains.command'

const httpClient = new AxiosClient()

export const getMultipleDomainsCommand = new GetMultipleDomainsCommand(httpClient, store)
